import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("tab", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(tab());
        const el = await page.find("ux-tab");
        expect(el).toHaveClass("hydrated");
    });

    it("should emit the correct event", async () => {
        const page = await newE2EPage();
        await page.setContent(tab());
        await page.waitForChanges();
        const tabNameEvent = await page.spyOnEvent("uxTabNameChange");
        const tabElement = await page.find("ux-tab");
        tabElement.setAttribute("name", "new-tab-name");
        await page.waitForChanges();
        expect(tabNameEvent).toHaveReceivedEventDetail({
            tabId: "ux-tab-content1",
            tabName: "new-tab-name"
        });
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(tab());
        const el = await page.find("ux-tab");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(tab());
    });
});

function tab() {
    return `
    <ux-tab name="Tab 1" tab-id="ux-tab-content1">
        Content
    </ux-tab>
    `;
}
